import _get from 'lodash/get'
import { baseRequest, consumerRequest } from '.'

export const linkTicket = async ({ eventId, ticketTypeId, categoryKey, seatsIoEventId = 'main' }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/events/${seatsIoEventId ?? 'main'}/link_ticket_type`, {
    ticketTypeId,
    categoryKey,
  })
  return _get(res, 'data')
}

export const unlinkTicket = async ({ eventId, ticketTypeId, categoryKey, seatsIoEventId = 'main' }) => {
  const res = await baseRequest.delete(`event/${eventId}/seats-io/events/${seatsIoEventId ?? 'main'}/unlink_ticket_type`, {
    data: {
      ticketTypeId,
      categoryKey,
    },
  })
  return _get(res, 'data')
}

export const fetchSeatsIoEvent = async (eventId, seatsIoEventId = 'main') => {
  const res = await baseRequest.get(`event/${eventId}/seats-io/events/${seatsIoEventId ?? 'main'}`)
  return _get(res, 'data.data.attributes')
}

export const fetchSeatsIoData = async (eventId,seatsIoEventId = 'main') => {
  const res = await baseRequest.get(`event/${eventId}/seats-io/events/${seatsIoEventId ?? 'main'}/configuration`)
  return _get(res, 'data.data.attributes')
}

export const reserveSeatsIo = async (eventId, seats, seatsIoEventId = 'main') => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/events/${seatsIoEventId ?? 'main'}/reserve_for_guest`, {
    seats,
  })
  return _get(res, 'data.data.attributes')
}

export const fetchSeatsIoMapsByVenue = async venueId => {
  const res = await baseRequest.get(`venue/${venueId}/seats-io/charts`)
  return _get(res, 'data.data.attributes')
}

export const fetchSeatsIoConfiguration = async () => {
  const res = await baseRequest.get(`event/seats-io/events/configuration`)
  return _get(res, 'data.data.attributes')
}

export const setSeatsIoData = async ({ eventId, chartKey, chartName, type = 'event', name = null }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/events`, {
    settings: {
      chartKey,
      chartName,
      type,
      name,
    },
  })
  return _get(res, 'data.data.attributes')
}

export const updateEvent = async ({eventId, seatsIoEventId, name}) => {
  const res = await baseRequest.patch(`event/${eventId}/seats-io/events/${seatsIoEventId}`, {
    name
  })

  return _get(res, 'data.data')
}

export const createSeasonEvent = async ({eventId, name}) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/season/main/events`, {
    name
  })

  return _get(res, 'data.data.attributes')
}

export const fetchSeatsIoInvitations = async (eventId, limit, page) => {
  const res = await baseRequest.get(
    `event/${eventId}/seats-io/events/main/invitations?page=${page}&limit=${limit}`,
  )
  return _get(res, 'data.data.attributes')
}

export const sendSeatsIoInvitations = async ({ eventId, email, seatsIoChannelId, promoterId }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/invitations`, {
    invitation: {
      email,
      seatsIoChannelId,
      promoterId,
    },
  })
  return _get(res, 'data.data.attributes')
}

export const createChannelSeatsIo = async ({ eventId, name, color }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/events/main/channels`, {
    channel: {
      name,
      color,
    },
  })
  return _get(res, 'data.data.attributes')
}

export const editChannelSeatsIo = async ({ eventId, name, color, channelId }) => {
  const res = await baseRequest.patch(`event/${eventId}/seats-io/events/main/channels/${channelId}`, {
    channel: {
      name,
      color,
    },
  })
  return _get(res, 'data.data.attributes')
}

export const removeChannelSeatsIo = async ({ eventId, channelId }) => {
  const res = await baseRequest.delete(`event/${eventId}/seats-io/events/main/channels/${channelId}`)
  return _get(res, 'data.data.attributes')
}

export const resendSeatsIoInvitation = async ({ eventId, invitationId }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/invitations/${invitationId}/resend`)
  return _get(res, 'data.data.attributes')
}

export const withdrawSeatsIoInvitation = async ({ eventId, invitationId }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/invitations/${invitationId}/withdraw`)
  return _get(res, 'data.data.attributes')
}

export const ordersSeatsIoInvitation = async ({ eventId, invitationId }) => {
  const res = await baseRequest.get(`event/${eventId}/seats-io/invitations/${invitationId}/orders`)
  return _get(res, 'data.data.attributes')
}

export const createChart = async data => {
  const res = await consumerRequest.post(`v1/seats-io/charts`, data)
  return _get(res, 'data.data.attributes')
}

export const createTag = async (chartKey, tag) => {
  const res = await consumerRequest.post(`v1/seats-io/charts/${chartKey}/tags/${tag}`)
  return _get(res, 'data.data.attributes')
}

export const deleteMap = async (eventId, seatsIoEventId = 'main') => {
  const res = await baseRequest.delete(`event/${eventId}/seats-io/events/${seatsIoEventId}`)
  return _get(res, 'data.data.attributes')
}

export const changeSeat = async (eventId, ticketId, data) => {
  const res = await baseRequest.patch(`event/${eventId}/seats-io/seat/${ticketId}`, { data })
  return _get(res, 'data.data.attributes')
}
